/**
 * 指標定義。docs/15-glossary.md 第3章を単一の正とする。
 * すべての指標は企業単位でユニークに数える。
 */
/** 観測期間の既定値（日）。組織設定 metrics.observationDays で上書きする */
export const DEFAULT_OBSERVATION_DAYS = 14;
/** 「傾向」と表現してよい最小件数（G06 / docs/07-ai-design.md 4.6） */
export const REFERENCE_THRESHOLD = 30;
export const emptyCounts = () => ({
    collectedCompanies: 0,
    sentCompanies: 0,
    failedCount: 0,
    unknownCount: 0,
    bounceCount: 0,
    needsActionCount: 0,
    skippedCount: 0,
    repliedCompanies: 0,
    appointmentCompanies: 0,
    negotiatingCompanies: 0,
    wonCompanies: 0,
    lostCompanies: 0,
});
export const addCounts = (a, b) => {
    const out = {};
    for (const key of Object.keys(a))
        out[key] = a[key] + b[key];
    return out;
};
/**
 * 率の計算。分母が 0 の場合は null を返す。
 * 画面では null を「—」と表示し、0% とは表示しない（docs/15-glossary.md 3.2）。
 */
export const rate = (numerator, denominator) => denominator > 0 ? numerator / denominator : null;
export const computeRates = (c) => ({
    replyRate: rate(c.repliedCompanies, c.sentCompanies),
    appointmentRate: rate(c.appointmentCompanies, c.sentCompanies),
    negotiationRate: rate(c.negotiatingCompanies, c.appointmentCompanies),
    winRate: rate(c.wonCompanies, c.negotiatingCompanies),
    sendSuccessRate: rate(c.sentCompanies, c.sentCompanies + c.failedCount + c.unknownCount + c.needsActionCount),
});
export const FUNNEL_LABELS = {
    collected: '収集',
    sent: '送信',
    replied: '返信',
    appointment: 'アポ',
    negotiating: '商談',
    won: '受注',
};
export const CHANNEL_METRIC_LABEL = {
    form: 'フォーム',
    email: 'メール',
};
/** 送信日 + 観測期間が現在を超えていれば「計測中」 */
export const isMeasuring = (sentAt, observationDays, now = new Date()) => sentAt.getTime() + observationDays * 86_400_000 > now.getTime();
//# sourceMappingURL=metrics.js.map